export class ArrayUtil {
    public static clear(array: any[]): void {
        array.length = 0;
    }

    public static pushAll(target: any[], origin: any[]): void {
        origin.forEach(item => target.push(item));
    }
}